












import Vue from "vue";
import Component from "vue-class-component";
import { LGeoJson } from "vue2-leaflet";
import { Layer } from "leaflet";
import { features } from "@/store";
import { IPipelines } from "@/store/features/models";

@Component({
  components: {
    LGeoJson,
  },
})
export default class PipelineLayer extends Vue {
  //computed
  get pipelines() {
    return features.getters.pipeLines;
  }
  get geoJsonOptions() {
    return {
      onEachFeature: this.onEachFeatureFunction,
    };
  }
  get styleFunction() {
    return () => {
      return {
        weight: 1,
        color: "black",
      };
    };
  }
  get onEachFeatureFunction() {
    return (feature: IPipelines, layer: Layer) => {
      layer.bindTooltip(feature.properties.nombre, {
        permanent: false,
        sticky: true,
      });
    };
  }

  //methods
  loadFeatures() {
    if (!this.pipelines.length) {
      features.dispatch("getPipelines");
    }
  }
  created() {
    this.loadFeatures();
  }
}
